import React, { useContext, useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { FBOSearchPost, contractOpportunititesPost, futureOpportunitiesSearchPost, businessSearchGet, purchaseSearchPost, contractingOfficerSearchPost } from '../../api';
import { UserContext } from '../../context/User';
import { Container } from 'react-bootstrap';
import { somethingWentWrongNotice } from '../UI/Notifications';
import date from 'date-and-time';
import { 
  FEDERAL_OPPORTUNITIES_GET_SELECT, 
  CONTRACT_OPPORTUNITIES_POST_SELECT, 
  BUSINESSES_GET_SELECT, 
  FUTURE_OPPORTUNITIES_GET_SELECT, 
  PURCHASES_GET_SELECT,
  CONTRACTING_OFFICER_POST_SELECT
} from '../../constans';
import SearchFrame from './SearchFrame';
import { SearchContext } from '../../context/Search';

const REQUESTS = {
  contract_opportunities: FBOSearchPost,
  b2b_opportunities: purchaseSearchPost,
  future_opportunities: futureOpportunitiesSearchPost,
  businesses: businessSearchGet,
  micro_purchases: contractOpportunititesPost,
  contracting_officer: contractingOfficerSearchPost
}

const Search = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const entity = query.get("entity");
  const search = query.get("search");
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [active, setActive] = useState(entity || "contract_opportunities");
  const [pageCount, setPageCount] = useState(0);
  const [searchedData, setSearchedData] = useState([]);
  const [forcePage, setForcePage] = useState(0);
  const [inputValues, setInputValues] = useState({
    search: search ? search : "",
    posted_date: {}
  })
  const [triggerSearch, setTriggerSearch] = useState(false);
  const { setUser, setIsLoggedIn, user } = useContext(UserContext);
  const history = useHistory();
  const [sorted, setSorted] = useState(false);
  const [orderByParams, setOrderByParams] = useState([]);
  const [currentInputValues, setCurrentInputValues] = useState({
    search: search ? search : "",
    posted_date: {}
  });
  const role = user && user.roles && user.roles[0].role_description;

  useEffect(() => {
    if (entity !== null) {
      setActive(entity);
      setSearchedData([]);
      setTotalCount(null);
      setOffset(0);
      setLimit(10);
      setSorted(false);
      setInputValues({ search: "", posted_date: {}});
    }
  }, [entity]);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  const setSelect = () => {
    let selects = [];

    switch (active) {
      case "contract_opportunities":
        selects = FEDERAL_OPPORTUNITIES_GET_SELECT
        break;
      case "b2b_opportunities":
        selects = PURCHASES_GET_SELECT 
        break;
      case "future_opportunities":
        selects = FUTURE_OPPORTUNITIES_GET_SELECT 
        break;
      case "businesses":
        selects = BUSINESSES_GET_SELECT 
        break;
      case "micro_purchases":
        selects = CONTRACT_OPPORTUNITIES_POST_SELECT
        break;
      case "contracting_officer":
        selects = CONTRACTING_OFFICER_POST_SELECT
        break;
      default:
    }

    return selects;
  }

  const searchHandler = () => {
    setLoading(true);

    setInputValues({
      ...currentInputValues
    })

    const fullTextParams = {
      limit: limit,
      offset: offset,
      select: setSelect(),
      order_by: active === "businesses" ? "time|desc" : "",
      search: inputValues.search
    };

    if (!fullTextParams.search) delete fullTextParams.search;
    if (!fullTextParams.order_by) delete fullTextParams.order_by;
    
    let data = Object.keys(inputValues.posted_date).length ? {posted_date: {...inputValues.posted_date}} : {};

    requestHandler(fullTextParams, data);
  }

  const sortHandler = (sort_by) => {
    setLoading(true);
    const fullTextParams = {
      limit: limit,
      offset: offset,
      select: setSelect(),
      order_by: sort_by && sort_by,
      search: inputValues.search
    };

    if (!fullTextParams.search) delete fullTextParams.search;
    if (!fullTextParams.order_by) delete fullTextParams.order_by;

    let data = Object.keys(inputValues.posted_date).length ? {posted_date: {...inputValues.posted_date}} : {};

    requestHandler(fullTextParams, data);
  }
  
  useEffect(() => {
    if (sorted) sortHandler(orderByParams);
    if (!sorted) searchHandler();
    if (active === 'contracting_officer' && role !== 'admin') history.push('/dashboard');
  }, [limit, offset, active, triggerSearch, orderByParams])

  const onSubmit = (e) => {
    e.preventDefault();
    setOffset(0);
    setTriggerSearch(!triggerSearch);
    setSorted(false);
    setOrderByParams([]);
    setInputValues({
      ...inputValues,
      ...currentInputValues
    })
  };

  const handleTimeCallback = (start, end, name, id) => {
    const from = date.format(start._d, 'YYYY-MM-DD');
    const to = date.format(end._d, 'YYYY-MM-DD');

    setCurrentInputValues({
      ...currentInputValues,
      posted_date: {
        from,
        to
      }
    })
  }

  const onChangeSearchHandler = event => {
    setCurrentInputValues({
      ...currentInputValues,
      search: event.target.value
    })
  }
  
  const requestHandler = (fullTextParams, data) => {
    REQUESTS[active](fullTextParams, data)
    .then(response => {
      setSearchedData(response.data.results);
      setTotalCount(response.data.total_count);
      setSorted(false);
      setLoading(false);
    })
    .catch(error => {
      if (error.response.status === 404) {
        setSearchedData([]);
        setTotalCount(0);
      } else {
        handleDefaultStatusCodes(error.response.status); 
      }
      
      setLoading(false);
    })
  }

  return (
    <section className="section-spaces">
      <Container>
        <SearchContext.Provider value={{
          active,
          currentInputValues,
          setCurrentInputValues,
          setOrderByParams,
          orderByParams,
          setSorted,
          sorted,
          onChangeSearchHandler,
          handleTimeCallback,
          onSubmit,
          inputValues,
          setInputValues,
          setSearchedData,
          searchedData,
          totalCount,
          limit,
          offset,
          setLimit,
          setOffset,
          forcePage,
          setForcePage,
          pageCount,
          setPageCount,
          loading
        }}>
          <SearchFrame />
        </SearchContext.Provider>
      </Container>
    </section>
  );
};

export default Search;